
import {SaleRow} from "@/models/base";
import {SaleRowService} from "@/services/sale-row-service";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			qty: 0,
			date: new Date(),
			creating: false
		};
	},
	props: {
		row: {
			type: Object as () => SaleRow,
			required: true
		}
	},
	methods: {
		cancel() {
			this.$emit("close");
		},
		async confirm() {
			if (this.creating) return;
			this.creating = true;
			try{
				let response = await SaleRowService.markAsDelivered([this.row], this.qty, this.date);
				if (response.undeliverableCount > 0) {
					this.$wf.notify(this.$ctc("sale-rows-set-to-undelivered", response.undeliverableCount), "info", 3000, "info-circle");
				}
				this.$wf.notify(this.$ctc("rows-changed-count", response.changedRows), "success", 3000, "check");
				this.$emit("finished");
				this.$emit("close");
			}catch(err){

			}finally {
				this.creating = false;
			}
		}
	},
	mounted() {
		this.qty = this.row.Backorder;
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
